/**
 * 生成指定进制的正则表达式验证器
 * @param {number} base - 进制数 (2-36)
 * @returns {RegExp} 验证正则表达式
 */
export function generateRegex(base) {
  const baseNum = parseInt(base)
  if (baseNum <= 10) {
    return new RegExp(`^[+\\-]?[0-${baseNum - 1}]*[.]?[0-${baseNum - 1}]*$`, 'gi')
  }
  
  const letter = String.fromCharCode(96 + baseNum - 10) // 'a' = 97
  return new RegExp(`^[+\\-]?[0-9a-${letter}]*[.]?[0-9a-${letter}]*$`, 'gi')
}

/**
 * 验证输入是否符合指定进制
 * @param {string} value - 输入值
 * @param {number} base - 进制数
 * @returns {boolean} 是否有效
 */
export function validateInput(value, base) {
  if (!value) return true
  const regex = generateRegex(base)
  const match = value.match(regex)
  return match && match[0] === value
}

/**
 * 将带小数点的字符串按指定进制转换为十进制
 * @param {string} numStr - 数字字符串
 * @param {number} fromBase - 源进制
 * @returns {number} 十进制数值
 */
export function parseFloatWithBase(numStr, fromBase) {
  const str = numStr.toString()
  const data = str.split('.')
  
  if (data.length === 1) {
    // 没有小数部分
    return parseInt(data[0], fromBase)
  }
  
  // 处理小数部分
  const fractionalDigits = data[1].split('')
  let sum = 0
  
  for (let i = 0; i < data[1].length; i++) {
    const digit = fractionalDigits[i]
    const digitValue = parseInt(digit, fromBase)
    sum += digitValue * Math.pow(fromBase, -1 * (i + 1))
  }
  
  return parseInt(data[0], fromBase) + sum
}

/**
 * 进制转换核心函数
 * @param {string} value - 输入值
 * @param {number} fromBase - 源进制
 * @param {number} toBase - 目标进制
 * @returns {string} 转换结果
 */
export function convertBase(value, fromBase, toBase) {
  if (!value) return ''
  
  // 验证输入
  if (!validateInput(value, fromBase)) {
    throw new Error(`输入不符合 ${fromBase} 进制格式`)
  }
  
  try {
    let decimal
    
    // 转换为十进制
    if (value.indexOf('.') === -1) {
      // 整数
      decimal = parseInt(value, fromBase)
    } else {
      // 小数
      decimal = parseFloatWithBase(value, fromBase)
    }
    
    // 从十进制转换到目标进制
    const result = decimal.toString(toBase)
    return result
  } catch (error) {
    throw new Error('转换失败，请检查输入')
  }
}
